<template>
    <div
        class="custom-option"
        :class="{
            'active' : showOptions,
            'up' : pullUp,
            'disable': disable
        }"
        @click="showOptions=!showOptions"
        @blur="showOptions=false"
        tabindex="0"
    >
        <div
            class="selected"
        >
            {{ selected }}
        </div>

        <ul v-if="showOptions && options.length > 0">
            <li
                class="option"
                v-for="(option, key) in options"
                :key="key"
                :class="{'selected' : value && option.value === value}"
                @click="select(option.value)"
            >
                {{ option.text }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
	props: {
		options: {
			type: Array,
			required: true
		},

		placeholder: {
			type: String,
			required: true
		},

		value: {
			type: String,
			default: null
		},

		disable: {
			type: Boolean,
			default: false
		},

		pullUp: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
			showOptions: false
		}
	},

	computed: {
		selected () {
			if (!this.value) return this.placeholder

			return this.options.find(x => x.value === this.value).text
		}
	},

	methods: {
		select (selectedValue) {
			if (this.disable) return

			this.$emit('input', selectedValue)
		}
	}
}
</script>

<style lang="scss" scoped>
.custom-option {
    position: relative;
    border: 1px solid #d0d0df;
    padding: 5px 10px;
    min-width: 90px;
    border-radius: 5px;
    font-size: 1em;
    height: 2.3em;
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    background-color: #fff;
    transition: 0.3s;

    &:after {
        content: '';
        display: inline-block;
        border-top: 2px solid #7A7D7E;
        border-right: 2px solid #7A7D7E;
        height: 5px;
        width: 5px;
        transform: rotateZ(135deg);
        pointer-events: none;
        margin-bottom: 2px;
    }

    &.disable {
        pointer-events: none;
        background-color: #f5f5f5;
    }

    .selected {
        flex: 1 1 auto;
        color: #777;
        line-height: 18px;
        margin-right: 5px;
    }

    ul {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        max-height: 400px;
        overflow: auto;
        background-color: #fff;
        border-radius: 5px;
        border: 1px solid #D9DEE2;
        padding: 0;
        list-style: none;
        margin-top: 10px;
        min-height: 25px;

        li {
            padding: 10px;
            width: 100%;
            font-size: 0.9rem;

            &.selected , &:hover {
                background-color: #eee;
            }
        }
    }

    &.active,
    &:focus,
    &.active ul,
    &:focus ul {
        border-color: #2DC4B6;
        outline: none;
    }

    &.up {
        &:after {
            transform: rotateZ(-45deg);
            margin-bottom: 0;
            margin-top: 2px;
        }

        ul {
            top: unset;
            bottom: 100%;
            margin-top: 0;
            margin-bottom: 10px;
        }
    }
}
</style>
